'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimePickerWrapper = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalWrapper = require('../wrappers/ModalWrapper');

var _ModalWrapper2 = _interopRequireDefault(_ModalWrapper);

var _TimePicker = require('./TimePicker');

var _TimePicker2 = _interopRequireDefault(_TimePicker);

var _propTypes3 = require('../constants/prop-types');

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _BasePicker = require('../_shared/BasePicker');

var _BasePicker2 = _interopRequireDefault(_BasePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimePickerWrapper = function TimePickerWrapper(props) {
  var value = props.value,
      format = props.format,
      autoOk = props.autoOk,
      onChange = props.onChange,
      ampm = props.ampm,
      fadeTimeout = props.fadeTimeout,
      forwardedRef = props.forwardedRef,
      seconds = props.seconds,
      other = (0, _objectWithoutProperties3.default)(props, ['value', 'format', 'autoOk', 'onChange', 'ampm', 'fadeTimeout', 'forwardedRef', 'seconds']);


  return _react2.default.createElement(
    _BasePicker2.default,
    props,
    function (_ref) {
      var date = _ref.date,
          handleAccept = _ref.handleAccept,
          handleChange = _ref.handleChange,
          handleClear = _ref.handleClear,
          handleDismiss = _ref.handleDismiss,
          handleSetTodayDate = _ref.handleSetTodayDate,
          handleTextFieldChange = _ref.handleTextFieldChange,
          isAccepted = _ref.isAccepted,
          pick12hOr24hFormat = _ref.pick12hOr24hFormat;
      return _react2.default.createElement(
        _ModalWrapper2.default,
        (0, _extends3.default)({
          ref: forwardedRef,
          value: value,
          format: pick12hOr24hFormat('hh:mm A', 'HH:mm'),
          onClear: handleClear,
          onAccept: handleAccept,
          onChange: handleTextFieldChange,
          onDismiss: handleDismiss,
          onSetToday: handleSetTodayDate,
          isAccepted: isAccepted
        }, other),
        _react2.default.createElement(_TimePicker2.default, {
          date: date,
          onChange: handleChange,
          ampm: ampm,
          fadeTimeout: fadeTimeout,
          seconds: seconds
        })
      );
    }
  );
};

exports.TimePickerWrapper = TimePickerWrapper;
TimePickerWrapper.propTypes = {
  /** DateTimepicker value */
  value: _propTypes4.default.date,
  /** Date format string for input */
  format: _propTypes2.default.string,
  /** Callback firing when date accepted */
  onChange: _propTypes2.default.func.isRequired,
  /** Auto accept date on minute selection */
  autoOk: _propTypes2.default.bool,
  /** 12h/24h view for hour selection clock */
  ampm: _propTypes2.default.bool,
  /** Switching hour/minutes animation timeout in milliseconds (set 0 to disable) */
  fadeTimeout: _propTypes2.default.number,
  /** Show the seconds view */
  seconds: _propTypes2.default.bool,
  forwardedRef: _propTypes2.default.func
};

TimePickerWrapper.defaultProps = {
  value: new Date(),
  format: undefined,
  autoOk: false,
  ampm: true,
  fadeTimeout: 400,
  forwardedRef: undefined,
  seconds: false
};

exports.default = _react2.default.forwardRef(function (props, ref) {
  return _react2.default.createElement(TimePickerWrapper, (0, _extends3.default)({}, props, { forwardedRef: ref }));
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-pickers/TimePicker/TimePickerWrapper.js
// module id = 1982
// module chunks = 0